// extracted by mini-css-extract-plugin
module.exports = {"pnButtonTitle":"pnButton-module--pnButtonTitle--FigRz"};